"use client";

import { useRouter } from "next/navigation";
import { Mail, ShoppingCart, User } from "lucide-react";
import { useCart } from "../data/CartContext";
import Link from "next/link";
import Image from "next/image";

const CartLogin = () => {
  const { cart } = useCart(); // ✅ Get cart data
  const router = useRouter(); // ✅ Router for navigation

  const handleCartClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault(); // Prevent default link behavior

    if (cart.length === 0) {
      alert("🛒 Your cart is empty! Redirecting to shop...");
      router.push("/shop"); // ✅ Redirect to shop
    } else {
      router.push("/shop/cart"); // ✅ Go to cart page
    }
  };

  return (
    <div className="flex items-center space-x-4 pr-0 lg:space-x-6 lg:pr-10">
      {/* Niki avatar — hidden below lg, where About rides in the hamburger drawer
          instead (see mobileAboutRoute in NavBar.tsx); no room for it next to
          the hamburger + discovery-call CTA on a phone. */}
      <Link
        href="/about/founder"
        aria-label="About Niki Charnock"
        title="About Niki"
        className="hidden lg:block shrink-0 rounded-full overflow-hidden h-8 w-8 md:h-9 md:w-9 ring-1 ring-[var(--border-on-dark)] hover:ring-[var(--accent-light)] transition"
      >
        <Image
          src="/images/Niki_Charnock.webp"
          alt=""
          width={72}
          height={72}
          className="h-full w-full object-cover object-top"
        />
      </Link>

      {/* Cart Icon with Conditional Click */}
      <a href="#" onClick={handleCartClick} className="relative" aria-label="View cart">
        <ShoppingCart
          className="text-[var(--text-on-dark)] hover:text-[var(--accent-light)] cursor-pointer h-5 w-5 md:h-6 md:w-6"
          aria-hidden
        />
        {cart.length > 0 && (
          <span className="absolute -top-2 -right-3 bg-[var(--accent)] text-[var(--ink)] text-xs px-2 py-1 rounded-full" aria-hidden>
            {cart.reduce((total, item) => total + item.qty, 0)}
          </span>
        )}
      </a>

      {/* Contact Icon */}
      <Link href="/contactus" aria-label="Contact us">
        <Mail
          className="text-[var(--text-on-dark)] hover:text-[var(--accent-light)] cursor-pointer h-5 w-5 md:h-6 md:w-6"
          aria-hidden
        />
      </Link>

      {/* Login Icon */}
      <Link href="/account" aria-label="Account">
        <User
          className="text-[var(--text-on-dark)] hover:text-[var(--accent-light)] cursor-pointer h-5 w-5 md:h-6 md:w-6"
          aria-hidden
        />
      </Link>
    </div>
  );
};

export default CartLogin;